import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { MapIcon, XIcon } from 'lucide-react';
import { funnelSteps } from '../data/funnel';
export function FunnelMap() {
  const [open, setOpen] = useState(false);
  const {
    pathname
  } = useLocation();
  return <div className="fixed bottom-4 right-4 z-50 print:hidden" data-id="element-24" data-mp="toyfopmac5ej">
      {open && <div className="mb-3 w-72 rounded-xl border border-navy-deep/10 bg-paper p-3 shadow-lift" data-id="element-25" data-mp="tr14x7fm5ui7">
          <p className="px-1 pb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-navy/50" data-id="element-26" data-mp="60xbfsw53b4x">
            Mapa del funnel
          </p>
          <nav className="flex flex-col" data-id="element-27" data-mp="fybg6v8pabhe">
            {funnelSteps.map((step, i) => {
          const active = pathname === step.path;
          return <Link key={step.path} to={step.path} onClick={() => setOpen(false)} className={`flex items-center gap-3 rounded-lg px-2 py-2 transition-colors duration-150 ease-out ${active ? 'bg-navy text-paper' : 'text-navy hover:bg-cream'}`} data-id="element-28" data-mp="1rcfc46yum9p3" data-mpi={i}>
                  <span className={`grid h-6 w-6 shrink-0 place-items-center rounded-md text-[11px] font-semibold ${active ? 'bg-gold text-navy-deep' : 'bg-cream text-navy/60'}`} data-id="element-29" data-mp="3uddn2ys2u8zc">
                    {i + 1}
                  </span>
                  <span className="min-w-0" data-id="element-30" data-mp="3bksznwv5cw2x">
                    <span className="block truncate text-sm font-semibold" data-id="element-31" data-mp="3blujoqu54sws">{step.label}</span>
                    <span className={`block truncate text-xs ${active ? 'text-gold-pale' : 'text-navy/50'}`} data-id="element-32" data-mp="3flbs9t4v6666">
                      {step.detail}
                    </span>
                  </span>
                </Link>;
        })}
          </nav>
        </div>}
      <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} className="flex items-center gap-2 rounded-full bg-navy-deep px-4 py-2.5 text-sm font-semibold text-paper shadow-lift transition-colors duration-150 ease-out hover:bg-navy" data-id="element-33" data-mp="2ruzcxx7ah75k">
        {open ? <XIcon className="h-4 w-4" data-id="element-34" data-mp="8rbvk0ngylyr" /> : <MapIcon className="h-4 w-4" data-id="element-35" data-mp="3t2523cow9jh" />}
        {open ? 'Cerrar' : 'Funnel'}
      </button>
    </div>;
}